var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 47",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Diagnostics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18.4 8.3 20.1 8.3 20.1 0 18.4 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 20.1 8.3 20.1 8.3 18.4 0 18.4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "27.3 9.4 28.6 10.7 33.8 5.4 32.5 4.2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "4.2 32.5 5.4 33.8 10.7 28.6 9.4 27.3"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "4.2 5.4 9.4 10.7 10.7 9.4 5.4 4.2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.2 19.9l28.2 28.1 5.6-5.6-28.1-28.2-5.7 5.7zm2.8 0l2.8-2.9 5.3 5.3-2.8 2.8-5.3-5.2zm6.8 6.7l2.8-2.8 18.6 18.6-2.8 2.8-18.6-18.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWand);
export default __webpack_public_path__ + "static/media/wand.9e60dc23571666a4e4942335832ebea0.svg";
export { ForwardRef as ReactComponent };